module.exports = __webpack_public_path__ + "static/media/cq_aggiungi b.a784d60f.svg";